
import Vue from 'vue'

const getFullPath = (mainPrefix: string, path: string) => {
  return `${mainPrefix}/${path}`
}

type BreadcrumbLink = {
  path: string
  name: string
  last: boolean
}

export default Vue.extend({
  name: 'BrowserBreadcrumbs',
  props: {
    mainPrefix: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  computed: {
    links(): Array<BreadcrumbLink> {
      const { mainPrefix } = this
      let arr: string[] = []
      if (this.path !== '/' && this.isDirectory) {
        arr = this.path.split('/')
      }
      if (this.path !== '/' && !this.isDirectory) {
        arr = this.path.split('/').slice(1)
      }
      let prefix = ''
      const result = [
        {
          path: getFullPath(mainPrefix, ''),
          name: 'All files',
          last: arr.length === 0,
        },
      ]
      arr.forEach((elm: any, index: number) => {
        prefix += `/${elm}`
        result.push({
          path: this.getFullPath(mainPrefix, prefix.slice(1)),
          name: elm,
          last: index == arr.length - 1,
        })
      })
      return result
    },
    isDirectory(): boolean {
      return !!this.$router.currentRoute.query.directory
    },
    directoryPath(): string {
      return this.$router.currentRoute.query?.directory as string
    },
  },
  methods: {
    getFullPath(mainPrefix: string, path: string): string {
      return this.isDirectory ? `${mainPrefix}/?directory=${path}` : `${mainPrefix}/${path}`
    },
  },
})
